import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ac0079',
    ecrans: ['00-2']
});
